import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "./index.css";
import "./styles/minorityReport.css";
import "./styles/scroll-fix.css";
import AppRouter from "./routes";
import theme from "./components/themes/VisionTheme";
import { VerimeterModeProvider } from "./contexts/VerimeterModeContext";

// Register service worker for push notifications
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch((err) =>
    console.warn("[sw] registration failed:", err)
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ColorModeScript initialColorMode="dark" />
    <ChakraProvider theme={theme}>
      <VerimeterModeProvider>
        <AppRouter />
      </VerimeterModeProvider>
    </ChakraProvider>
  </React.StrictMode>
);
